import { DialogTitle } from "@mui/material";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useResetCustomerDependentControls } from "pages/common/hooks/use-reset-customer-dependent-controls";
import { useCallback, useEffect, useMemo, useState } from "react";
import { DialogComplexContent } from "share-components/templates/form/dialog-complex-form/dialog-complex-content";
import { DialogComplexFormContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form";
import { DialogComplexFormArrayContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form-array";

import { workOrderBusiness } from "api/bussiness/work-order/work-order-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { createProductOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { IUpdateWorkOrder } from "mobx-stores/_models/work-order/work-order";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getEditWorkOrderFormSchema } from "../schema";

export const EditWorkOrder = observer(() => {
  const {
    workOrderManagement: {
      openEdit,
      getWorkOrderDetail,
      setProp,
      workOrderDetail,
    },
  } = useStores();
  const [enableDependentReset, setEnableDependentReset] = useState(false);
  const {
    form: { controls, isValid },
    getControl,
    getControlArray,
    setDefaults,
    submitHandler,
  } = useForm<IUpdateWorkOrder>((form) => getEditWorkOrderFormSchema(form), {
    id: "",
    date: dateTimeToUTCString(dayjs()),
    woNumber: "",
    customerId: "",
    note: "",
    purchaseOrderId: "",
    items: [],
  });

  useEffect(() => {
    if (workOrderDetail) {
      setEnableDependentReset(false);

      setDefaults({
        id: workOrderDetail.id,
        date: workOrderDetail.date,
        woNumber: workOrderDetail.woNumber,
        customerId: workOrderDetail.customerId,
        note: workOrderDetail.note,
        purchaseOrderId: workOrderDetail.purchaseOrderId,
        items: workOrderDetail.items.map((x) => ({
          id: x.id,
          amount: x.amount,
          finishedAmount: x.finishedAmount,
          productionAmount: x.productionAmount,
          wastageAmount: x.wastageAmount,
          note: x.note,
          productId: x.productId,
        })),
      });
      if (workOrderDetail.items && workOrderDetail.items.length > 0) {
        getControl("items").children.forEach((row: IControl[]) => {
          const idCtr = row.filter((x) => x.name === "id")?.[0];
          const data = workOrderDetail.items.filter(
            (x) => idCtr && x.id === idCtr.value,
          )?.[0];
          const productIdCtr = row.filter((x) => x.name === "productId")?.[0];
          if (productIdCtr && data.product) {
            productIdCtr.setProp("optionItems", [
              {
                label: createProductOptionLabel(data.product),
                value: data.product?.id,
              },
            ]);
          }
        });
      }

      setEnableDependentReset(true);
    }
  }, [getControl, workOrderDetail, setDefaults]);

  // useEffect(() => {
  //   const customerCtr = getControl("purchaseOrderId");
  //   customerCtr.setProp("optionItems", [
  //     {
  //       value: workOrderDetail?.purchaseOrderId,
  //       label: `${workOrderDetail?.purchaseOrder?.poNumber || ""}`,
  //     },
  //   ]);
  // }, [
  //   workOrderDetail?.purchaseOrder?.poNumber,
  //   workOrderDetail?.purchaseOrderId,
  //   getControl,
  // ]);

  useEffect(() => {
    const customerSelection = getControl("customerId");
    customerSelection.setProp("optionItems", [
      {
        label: workOrderDetail?.customer?.dealingName || "",
        value: workOrderDetail?.customer?.id,
      },
    ]);
  }, [
    getControl,
    workOrderDetail?.customer?.dealingName,
    workOrderDetail?.customer?.id,
  ]);

  const saveHandler = useCallback(
    async (data: IUpdateWorkOrder) => {
      try {
        if (!workOrderDetail?.id) return;
        await workOrderBusiness.update(workOrderDetail?.id, data);
        await getWorkOrderDetail(workOrderDetail?.id);
        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getWorkOrderDetail, workOrderDetail?.id, setProp],
  );

  const itemControl = useMemo(() => {
    return getControl("items");
  }, [getControl]);

  const customerControl = useMemo(() => {
    return getControl("customerId");
  }, [getControl]);

  useResetCustomerDependentControls({
    customerId: customerControl.value,
    arrayChildControls: [
      {
        arrayControl: itemControl,
        childControlName: "productId",
      },
    ],
    enabled: enableDependentReset,
  });

  const workOrderItems = useMemo(() => {
    return getControlArray("items");
  }, [getControlArray]);

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa lệnh sản xuất</DialogTitle>
      <DialogComplexContent>
        <DialogComplexFormContainer>
          <DynamicForm controls={controls}></DynamicForm>
        </DialogComplexFormContainer>
        <DialogComplexFormArrayContainer label={itemControl.label}>
          {workOrderItems && workOrderItems.length > 0 && (
            <DynamicFormArray
              controlSpacing={2}
              containerProps={{
                sx: {
                  marginTop: "10px",
                  marginBottom: "10px",
                },
              }}
              children={workOrderItems}
            ></DynamicFormArray>
          )}
        </DialogComplexFormArrayContainer>
      </DialogComplexContent>
    </DialogForm>
  );
});
